import { useForm } from '@refinedev/antd';
import { BaseKey } from '@refinedev/core';
import {
  Checkbox,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  ModalProps,
  Spin,
  Card,
} from 'antd';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { useState } from 'react';

export const FootballFestMatchEditModal = ({
  recordId,
  onClose,
  ...props
}: ModalProps & {
  recordId: BaseKey;
  onClose: () => void;
}) => {
  const [updateStatus, setUpdateStatus] = useState<boolean>(false);
  const { formProps, form, formLoading } = useForm({
    action: 'edit',
    resource: 'football-fest/match',
    id: recordId,
    onMutationSuccess: () => {
      onClose();
    },
    successNotification: (data) => {
      return {
        message: `Updated match ${data?.data.id}`,
        type: 'success',
      };
    },
  });

  if (formLoading) {
    return (
      <Modal
        {...props}
        onOk={() => form.submit()}
        okText="Save"
        onCancel={onClose}
      >
        <Spin spinning />
      </Modal>
    );
  }

  const { teamA, teamB, startTime, endTime, metadata, canResultBeDraw } =
    formProps.initialValues || {};

  const isMatchResultReady = ({
    metadata,
    canResultBeDraw,
  }: {
    metadata: any;
    canResultBeDraw: boolean;
  }) => {
    if (
      typeof get(metadata, ['score', 'fulltime', 'home']) !== 'number' ||
      typeof get(metadata, ['score', 'fulltime', 'away']) !== 'number'
    ) {
      return false;
    }

    if (
      get(metadata, ['score', 'fulltime', 'home']) !==
      get(metadata, ['score', 'fulltime', 'away'])
    ) {
      return true;
    }

    if (canResultBeDraw) {
      return true;
    }

    if (
      typeof get(metadata, ['score', 'extratime', 'home']) !== 'number' ||
      typeof get(metadata, ['score', 'extratime', 'away']) !== 'number'
    ) {
      return false;
    }

    if (
      get(metadata, ['score', 'extratime', 'home']) !==
      get(metadata, ['score', 'extratime', 'away'])
    ) {
      return true;
    }

    if (
      typeof get(metadata, ['score', 'penalty', 'home']) !== 'number' ||
      typeof get(metadata, ['score', 'penalty', 'away']) !== 'number'
    ) {
      return false;
    }

    return true;
  };

  return (
    <Modal
      {...props}
      onOk={() => {
        if (formProps.initialValues) {
          form.setFieldsValue({
            updateStatus: updateStatus,
          });
        }
        form.submit();
      }}
      okText="Save"
      onCancel={onClose}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Can match have draw result?"
          valuePropName="checked"
          name={['canResultBeDraw']}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Checkbox />
        </Form.Item>
        <Form.Item label="Display priority" name={['displayPriority']}>
          <InputNumber min={0} defaultValue={0} />
        </Form.Item>
        <Form.Item
          label="Is active"
          name={['isActive']}
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item
          label="Start time"
          name={['startTime']}
          rules={[{ required: true }]}
          getValueProps={(value) => ({
            value: value ? dayjs(value) : undefined,
          })}
        >
          <DatePicker showTime />
        </Form.Item>
        <Form.Item
          label="End time"
          name={['endTime']}
          rules={[{ required: true }]}
          getValueProps={(value) => ({
            value: value ? dayjs(value) : undefined,
          })}
        >
          <DatePicker showTime />
        </Form.Item>

        <Card
          title="Update match ratio"
          style={{
            backgroundColor: '#e4e4e4',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignContent: 'center',
            }}
          >
            <Form.Item label={teamA} name={['teamAScore']}>
              <InputNumber min={0} defaultValue={0} />
            </Form.Item>
            <Form.Item label={teamB} name={['teamBScore']}>
              <InputNumber min={0} defaultValue={0} />
            </Form.Item>
          </div>
        </Card>
        <Card style={{ marginTop: 16, backgroundColor: '#e4e4e4' }}>
          <Form.Item name="updateStatus" valuePropName="checked">
            <span style={{ fontWeight: 'bold' }}>Current Status: </span>
            {dayjs().isBefore(startTime) ? (
              <span style={{ fontWeight: 'bold', color: 'orange' }}>
                Not yet started
              </span>
            ) : dayjs().isAfter(endTime) &&
              isMatchResultReady({ metadata, canResultBeDraw }) ? (
              <span style={{ fontWeight: 'bold', color: 'red' }}>End</span>
            ) : (
              <div>
                <div>
                  <span style={{ fontWeight: 'bold', color: 'green' }}>
                    In Match
                  </span>
                </div>
                <Checkbox
                  name="updateStatus"
                  onChange={() => {
                    if (formProps.initialValues) {
                      setUpdateStatus(!updateStatus);
                    }
                  }}
                />
                <span
                  style={{
                    marginLeft: 8,
                    fontWeight: 'bold',
                    color: 'red',
                  }}
                >
                  Update the status to "End match"
                </span>
              </div>
            )}{' '}
            <div></div>
          </Form.Item>
        </Card>
      </Form>
    </Modal>
  );
};
